const fonts = {
    body: 'Poppins',
    heading: 'Poppins',
    mono: 'Poppins',
}

export default fonts
